import defineThemeMiddleware from '#shared/util/defineThemeMiddleware.js';
import { pageSchema } from '#shared/schema/page.js';
import { themeSchema } from '#shared/schema/theme.js';
import { formSchema } from '#shared/schema/form.js';
import { urlSchema } from '#shared/schema/url.js';
import { appSchema } from '#shared/schema/app.js';
import { providerSchema } from '#shared/schema/provider.js';

import { getRequestHeader } from '#backend/util/request.js';

/**
 * Update cart data object to contain all required data
 */
export default defineThemeMiddleware(({ env, isServerProcess, isClientProcess, route, store, request, response }) => {
	// Set shared page data
	store.commit('SET_PAGE', pageSchema({
		route
	}));
	if (isServerProcess) {
		// Set server theme data
		store.commit('SET_THEME', themeSchema({
			request,
			response
		}));
		// Set server URL data
		store.commit('SET_URL', urlSchema({
			route,
			store,
			request,
			response
		}));
		// Set server form data
		store.commit('SET_FORM', formSchema({
			response
		}));
		// Set app data
		store.commit('SET_APP', appSchema({
			env,
			route,
			request,
			response
		}));
		// Set provider data
		store.commit('SET_PROVIDER', providerSchema({
			env,
			route,
			request,
			response
		}));
		// Set polyfills
		const userAgent = getRequestHeader(request, 'user-agent', '');
		store.commit('SET_POLYFILLS', {
			isObsoleteMac: /^(?!.*(?:chrome|edge)).*applewebkit\/(5|60[03]).*$/i.test(userAgent) // all OS versions before MacOS 10.11 including (ElCapitan), no chrome or edge
		});
	}
	if (isClientProcess) {
		// Set client URL data
		store.commit('SET_URL', urlSchema({
			route,
			store,
			location: window.location
		}));
	}
});
